const PSOrientationBaseController = require('./PSOrientationBaseController');

const PositionData = cc.Class({
    name: 'PositionData',
    properties: {
        isAbsoluteX: true,
        isAbsoluteY: true,
        x: 0,
        y: 0
    }
});

cc.Class({
    extends: PSOrientationBaseController,

    properties: {
        target: cc.Node,

        syncMobile: {
            default: false,
            notify: function() {
                if(this.syncMobile) {
                    this.copyDesktopDataToMobile();
                }
            }
        },

        landscapeDesktop: {
            type: PositionData,
            default: null,
        },
        portraitDesktop: {
            type: PositionData,
            default: null,
        },
        landscapeMobile: {
            type: PositionData,
            default: null,
        },
        portraitMobile: {
            type: PositionData,
            default: null,
        }
    },

    onLoad () {
        this._super();

        if (!this.target) {
            this.target = this.node;
        }

        this.origin = {
            x: this.target.x,
            y: this.target.y
        }

        this.isLoaded = true;

        if (this.lastConfig) {
            this._layout(this[this.lastConfig]);
        }
    },

    onLandscapeMobile () {
        this.lastConfig = 'landscapeMobile';
        this._layout(this.landscapeMobile);
    },

    onPortraitMobile () {
        this.lastConfig = 'portraitMobile';
        this._layout(this.portraitMobile);
    },

    onLandscapeDesktop () {
        this.lastConfig = 'landscapeDesktop';
        this._layout(this.landscapeDesktop);
    },

    onPortraitDesktop () {
        this.lastConfig = 'portraitDesktop';
        this._layout(this.portraitDesktop);
    },

    _layout (positionData) {
        if (!this.isLoaded) {
            return;
        }
        
        const initialX = positionData.isAbsoluteX ? 0 : this.origin.x;
        const initialY = positionData.isAbsoluteY ? 0 : this.origin.y;

        this.target.x = positionData.x + initialX;
        this.target.y = positionData.y + initialY;
    },

    copyDesktopDataToMobile () {
        this.copyFromTo(this.landscapeDesktop, this.landscapeMobile);
        this.copyFromTo(this.portraitDesktop, this.portraitMobile);
    },

    copyFromTo (from, to) {
        if (!from  || !to) {
            return;
        }

        to.isAbsoluteX = from.isAbsoluteX;
        to.isAbsoluteY = from.isAbsoluteY;
        to.x = from.x;
        to.y = from.y;

        cc.log('PSPositionOrientation synced');
    }
});
